import postalOperatorsMapper from '../mappers/postalOperatorsMapper';
import { RETRIEVE_INBOUND_MRD_POSTAL_OPERATOR_SUCCESS } from '../actions/types/ArrivalPostalOperatorActionTypes';
import { LOGGED_OUT } from '../../../../../core/modules/security/redux/actions/types/SecurityActionTypes';

export const initialState = [];

export const inboundPostalOperatorReducer = (state = initialState, action) => {
  switch (action.type) {
    case RETRIEVE_INBOUND_MRD_POSTAL_OPERATOR_SUCCESS:
      return postalOperatorsMapper(action.payload);
    case LOGGED_OUT:
      return initialState;
    default:
      return state;
  }
};

